<template>
  <div>
    <van-sticky :offset-top="46">
    <van-search
      v-model="queryParams.name"
      shape="round"
      show-action
      background="#4fc08d"
      clearable
      placeholder="请输入搜索关键词"
    >
      <template #action>
        <div style="padding: 0px 4px;" @click="handleRefresh">搜索</div>
      </template>
    </van-search>
    </van-sticky>
    <page-list ref='pageList' request-url="/sys/account" :getParams="getQueryParams">
      <template #row="{row}">
        <van-row style="background-color:rgba(172,201,220,0.19);line-height: 32px;border-radius: 6px;padding: 6px 10px">
          <van-col span="18">账号: {{row.account}}</van-col>
          <van-col span="6"><van-tag v-if = "row.status === '1'" type="success">启用</van-tag><van-tag v-else >禁用</van-tag></van-col>
          <van-col span="18">昵称: {{row.name}}</van-col>
          <van-col span="6">{{formatAccountType(row.accountType)}} <van-tag v-if = 'row.isAdvanceUser === 1' type="success">预存</van-tag></van-col>
          <van-col span="24">注册时间: {{row.createTime}}</van-col>
          <van-col span="24">锁定坐标: {{row.lockedLocation}}</van-col>
        </van-row>
      </template>
    </page-list>
    <down-drawer ref='userDrawer' @close="handleClose" @confirm="handleSubmit" title="编辑用户" >
      <template #content>
        <van-form ref="form" :validate-first="true" :show-error-message="false">
          <van-field
            v-model="model.username"
            disabled
            name="账号"
            label="账号"
            placeholder="请输入账号"
            :rules="[{ required: true, message: '账号不能为空' }]"
          />
          <van-field
            v-model="model.nickname"
            name="昵称"
            label="昵称"
            placeholder="请输入昵称"
          />
          <van-field name="uploader" label="头像">
            <template #input>
              <image-uploader v-model="model.avatar" />
            </template>
          </van-field>
          <van-field
            v-model="model.phone"
            name="手机号"
            label="手机号"
            placeholder="请输入手机号"
          />
        </van-form>
      </template>
    </down-drawer>
  </div>
</template>

<script>
import PageList from '@/components/tools/PageList'
export default {
  name: 'UserList',
  components: { PageList },
  data () {
    return {
      queryParams: {
        name: null
      },
      url: {
        imgerver: window._CONFIG.staticDomainUrl
      },
      show: false,
      model: {}
    }
  },
  methods: {
    formatAccountType (type) {
      if (type === 'CUST') {
        return '客户'
      } else if (type === 'POS') {
        return '商家'
      } else if (type === 'DRIVER') {
        return '司机'
      } else if (type === 'COURIER') {
        return '配送员'
      } else if (type === 'KEEPER') {
        return '仓管'
      }
      return '未知类型'
    },
    getQueryParams (params) {
      const param = Object.assign({}, params)
      param.name = this.queryParams.name
      return { params: JSON.stringify(param) }
    },
    getAvatarView: function (avatar) {
      if (avatar && avatar.indexOf('http') !== -1) {
        return avatar
      } else {
        return this.url.imgerver + '/' + avatar
      }
    },
    handleEdit (row) {
      this.model = {}
      this.$refs.userDrawer.show = true
      this.model = Object.assign({}, row)
    },
    handleSubmit () {
      // 触发表单验证
      this.$refs.form.validate().then(() => {
        const formData = {
          id: this.model.id,
          username: this.model.username,
          nickname: this.model.nickname,
          phone: this.model.phone,
          avatar: this.model.avatar,
          roleIds: this.model.roleIds
        }
        this.$api.user.updateUser(formData).then((res) => {
          if (res.success) {
            this.$toast.success(res.msg)
            this.$refs.userDrawer.show = false
          } else {
            this.$toast.fail(res.msg)
          }
        })
      }).catch((err) => {
        console.log('验证失败', err)
      })
    },
    handleRefresh () {
      this.$refs.pageList.onRefresh(20, false)
    }
  }
}
</script>

<style lang="less" scoped>
  .avatar{
    width: 84px;
    height: 84px;
    vertical-align: middle;
    padding: 8px 0px;
    border-radius: 50%;
  }
</style>
